import type { AccountingTagApiResource, AccountingTag, AccountingTagTarget } from "../types/accountingTags.types";

/** Les couleurs proposées, dans l'ordre où un nouveau tag les prend ; toute autre reste possible. */
export const TAG_COLORS = [
  { hex: "#7c3aed", name: "Violet" },
  { hex: "#2563eb", name: "Bleu" },
  { hex: "#0891b2", name: "Cyan" },
  { hex: "#0d9488", name: "Sarcelle" },
  { hex: "#16a34a", name: "Vert" },
  { hex: "#ca8a04", name: "Moutarde" },
  { hex: "#ea580c", name: "Orange" },
  { hex: "#dc2626", name: "Rouge" },
  { hex: "#db2777", name: "Rose" },
  { hex: "#64748b", name: "Ardoise" },
] as const;

/** La couleur d'un nouveau tag : la première de la palette que le catalogue n'utilise pas encore. */
export function nextTagColor(used: string[]): string {
  const taken = new Set(used.map((hex) => hex.toLowerCase()));
  return (TAG_COLORS.find((color) => !taken.has(color.hex)) ?? TAG_COLORS[used.length % TAG_COLORS.length]).hex;
}

export const sameTagName = (left: string, right: string) =>
  left.trim().toLocaleLowerCase("fr") === right.trim().toLocaleLowerCase("fr");

export const TAG_TARGET_LABELS: Record<AccountingTagTarget, { title: string, records: string, screen: string }> = {
  bank_movement: { title: "Tags des mouvements", records: "mouvements", screen: "Rapprochement bancaire" },
  ledger_allocation: { title: "Tags des affectations", records: "affectations", screen: "Grand livre" },
};

export const fromApiAccountingTag = (resource: AccountingTagApiResource): AccountingTag => ({
  id: resource.id,
  name: resource.name,
  color: resource.color,
  archived: resource.archived,
  target: resource.target,
  usageCount: resource.usage_count,
});
